<div [ngClass]="['b-navigation__shortcut-item', (selected || rla.isActive) ? 'b-navigation__shortcut-item--is-selected':'']"  
    routerLinkActive #rla="routerLinkActive" [routerLinkActiveOptions]="{exact:true}">
    <ng-template [ngIf]="link">
        <a [href]="link" *ngIf="label" [innerHTML]="label" [attr.target]="target"></a>
        <a [href]="link" *ngIf="!label" [attr.target]="target">
            <ng-content></ng-content>
        </a>
    </ng-template>
    <ng-template [ngIf]="!link && routerLink!==undefined">
        <a  
            [routerLink]="routerLink" *ngIf="label" [innerHTML]="label" [state]="routerState"></a>
        <a 
            [routerLink]="routerLink" *ngIf="!label" [state]="routerState">
            <ng-content></ng-content>
        </a>
        <a *ngFor="let altLink of alternativeRoutes" [routerLink]="altLink"></a>
    </ng-template>
    <ng-template [ngIf]="!link && routerLink===undefined">
        <div *ngIf="label" [innerHTML]="label"></div>
        <div *ngIf="!label">
            <ng-content></ng-content>
            <div *ngIf="arrowPointer" class="b-drawer-arrow">
                <span class="b-pointer__arrow"></span>
            </div>
        </div>
    </ng-template>
</div>